import {useUniversalFetch} from '#imports';
import {OntologyReadsApi, BriefApi, SearchProposalApi} from '@api';
import {apiConfiguration} from '~/configuration/apiConfiguration';
import type {LanguageItemResponse} from '~/types/ConditionBrief';

export function briefApisService() {
    const ontologyReadsApi = new OntologyReadsApi(apiConfiguration);
    const briefApi = new BriefApi(apiConfiguration);
    const searchProposalApi = new SearchProposalApi(apiConfiguration);

    function fetchAllLanguages() {
        return useUniversalFetch<LanguageItemResponse[]>('/api/language');
    }

    return {
        fetchAllLanguages,
        ontologyReadsApi,
        briefApi,
        searchProposalApi,
    };
}
